// assets/js/modules/projectItemCursor.js
// Shared cursor overlay that follows the mouse across all project items.
// Hover zone = __media-inner, which matches the exact media dimensions.

let cursor = null;
let controllers = []; 
let mouseX = 0;
let mouseY = 0;

function updateCursorPosition() {
  const hw = cursor.offsetWidth / 2;
  const hh = cursor.offsetHeight / 2;
  cursor.style.left = `${Math.min(Math.max(mouseX, hw), window.innerWidth - hw)}px`;
  cursor.style.top  = `${Math.min(Math.max(mouseY, hh), window.innerHeight - hh)}px`;
}

function setCursorContent(link) {
  const title = link?.dataset.title || '';
  const services = JSON.parse(link?.dataset.services || '[]');
  cursor.innerHTML = `
    <h3 class="project-cursor__title">${title}</h3>
    ${services.length ? `<ul class="project-cursor__services">
      ${services.map(s => `<li><span class="tag">${s}</span></li>`).join('')}
    </ul>` : ''}
  `;
}

export function init() {
  cursor = document.createElement('div');
  cursor.className = 'project-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  document.body.appendChild(cursor);

  const ctrl = new AbortController();
  controllers.push(ctrl);
  const { signal } = ctrl;

  // Track mouse position at all times
  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }, { signal, passive: true });

  // On scroll: re-check which element is under the cursor
  window.addEventListener('scroll', () => {
    const el = document.elementFromPoint(mouseX, mouseY);
    const inner = el?.closest('.project-item__media-inner');
    if (inner) {
      // Still over a media — update position (viewport shifted) and keep visible
      updateCursorPosition();
      cursor.classList.add('is-visible');
    } else {
      cursor.classList.remove('is-visible');
    }
  }, { signal, passive: true });

  document.querySelectorAll('.project-item__media-inner').forEach(inner => {
    const link = inner.closest('.project-item__link');

    inner.addEventListener('mouseenter', () => {
      setCursorContent(link);
      updateCursorPosition();
      cursor.classList.add('is-visible');
    }, { signal });

    inner.addEventListener('mousemove', () => {
      updateCursorPosition();
    }, { signal });

    inner.addEventListener('mouseleave', () => {
      cursor.classList.remove('is-visible');
    }, { signal });
  });
}

export function destroy() {
  cursor?.remove();
  cursor = null;
  controllers.forEach(c => c.abort());
  controllers = [];
}
